import NBType, { InferType } from '@netbase/nb-type'
import AnalysisType from '../enums/AnalysisType'
import AnnotationDisplayMode from '../enums/AnnotationDisplayMode'
import AuthorSchema from './AuthorSchema'
import AuthorTypeGroup from '../enums/AuthorTypeGroup'
import CVLogoSchema from './CVLogoSchema'
import CountType from '../enums/CountType'
import DayHourSchema from './DayHourSchema'
import Followers from '../enums/Followers'
import Gender from '../enums/Gender'
import GeoDisplaySchema from './GeoDisplaySchema'
import GeoFencingSchema from './GeoFencingSchema'
import InsightViewOption from '../enums/InsightViewOption'
import Interest from '../enums/Interest'
import Language from '../enums/Language'
import LxnxFilterSchema from './LxnxFilterSchema'
import MeasurementFilterSchema from './MeasurementFilterSchema'
import MediaType from '../enums/MediaType'
import OrganicPaidPostType from '../enums/OrganicPaidPostType'
import OwnedEarned from '../enums/OwnedEarned'
import PostSchema from './PostSchema'
import PostTypeGroup from '../enums/PostTypeGroup'
import Precision from '../enums/Precision'
import Profession from '../enums/Profession'
import ScopedStringListSchema from './ScopedStringListSchema'
import Sentiment from '../enums/Sentiment'
import SentimentDriverSchema from './SentimentDriverSchema'
import SocialWebChannelSchema from './SocialWebChannelSchema'
import Source from '../enums/Source'
import ThemeInfoListSchema from './ThemeInfoListSchema'
import TimeInterval from '../enums/TimeInterval'
import TopicInfoSchema from './TopicInfoSchema'
import VerifiedUsers from '../enums/VerifiedUsers'
import WidgetType from '../enums/WidgetType'

const SocialWebAuthorsWidgetSchema = NBType.object().shape('SocialWebAuthorsWidgetSchema', {
  analysisType: NBType.enum(AnalysisType),
  annotations: NBType.array().of(NBType.enum(AnnotationDisplayMode)),
  authorTypeGroups: NBType.array().of(NBType.enum(AuthorTypeGroup)),
  countType: NBType.enum(CountType),
  cvLogos: NBType.array().of(CVLogoSchema),
  dayHours: NBType.array().of(DayHourSchema),
  endDatetime: NBType.number(),
  excludedAuthors: NBType.array().of(AuthorSchema),
  excludedBioTexts: NBType.array().of(NBType.array().of(NBType.string())),
  excludedChannels: NBType.array().of(SocialWebChannelSchema),
  excludedDomains: NBType.array().of(NBType.string()),
  excludedEmojis: NBType.array().of(NBType.string()).nullable(),
  excludedGeographies: NBType.array().of(NBType.array().of(NBType.string())),
  excludedGeographiesSummary: NBType.array().of(NBType.array().of(GeoDisplaySchema)),
  excludedInterests: NBType.array().of(NBType.enum(Interest)),
  excludedLanguages: NBType.array().of(NBType.enum(Language)),
  excludedPosts: NBType.array().of(NBType.array().of(PostSchema)),
  excludedProductHierarchy: NBType.array().of(NBType.array().of(NBType.string())),
  excludedProfessions: NBType.array().of(NBType.enum(Profession)),
  excludedSentimentDriver: SentimentDriverSchema,
  excludedTerms: NBType.array().of(ScopedStringListSchema),
  excludedUserTags: NBType.array().of(NBType.array().of(NBType.string())),
  followers: NBType.array().of(NBType.enum(Followers)),
  genders: NBType.array().of(NBType.enum(Gender)),
  geoFencings: NBType.array().of(NBType.array().of(GeoFencingSchema)),
  includedAuthors: NBType.array().of(AuthorSchema),
  includedBioTexts: NBType.array().of(NBType.array().of(NBType.string())),
  includedChannels: NBType.array().of(SocialWebChannelSchema),
  includedDomains: NBType.array().of(NBType.string()),
  includedEmojis: NBType.array().of(NBType.string()).nullable(),
  includedGeographies: NBType.array().of(NBType.array().of(NBType.string())),
  includedGeographiesSummary: NBType.array().of(NBType.array().of(GeoDisplaySchema)),
  includedInterests: NBType.array().of(NBType.enum(Interest)),
  includedLanguages: NBType.array().of(NBType.enum(Language)),
  includedPosts: NBType.array().of(NBType.array().of(PostSchema)),
  includedProductHierarchy: NBType.array().of(NBType.array().of(NBType.string())),
  includedProfessions: NBType.array().of(NBType.enum(Profession)),
  includedSentimentDriver: SentimentDriverSchema,
  includedTerms: NBType.array().of(ScopedStringListSchema),
  includedUserTags: NBType.array().of(NBType.array().of(NBType.string())),
  lxnxFilter: LxnxFilterSchema,
  mediaTypes: NBType.array().of(NBType.enum(MediaType)),
  name: NBType.string(),
  netPromoterScores: NBType.array().of(MeasurementFilterSchema),
  organicPaidPostTypes: NBType.array().of(NBType.enum(OrganicPaidPostType)),
  ownedEarned: NBType.array().of(NBType.enum(OwnedEarned)),
  parentAnalysisType: NBType.enum(AnalysisType),
  posX: NBType.number(),
  posY: NBType.number(),
  postTypeGroups: NBType.array().of(NBType.enum(PostTypeGroup)),
  precision: NBType.enum(Precision),
  primaryTerms: NBType.array().of(NBType.string()),
  removedInsights: NBType.array().of(NBType.string()),
  selectedTopic: TopicInfoSchema,
  sentiments: NBType.array().of(NBType.enum(Sentiment)),
  sizeX: NBType.number(),
  sizeY: NBType.number(),
  sources: NBType.array().of(NBType.enum(Source)),
  starRatings: NBType.array().of(MeasurementFilterSchema),
  startDatetime: NBType.number(),
  surveyScores: NBType.array().of(MeasurementFilterSchema),
  themeInfos: NBType.array().of(ThemeInfoListSchema),
  timeInterval: NBType.enum(TimeInterval),
  topN: NBType.number(),
  topicInfos: NBType.array().of(TopicInfoSchema),
  type: NBType.enum(WidgetType),
  verifiedUsers: NBType.array().of(NBType.enum(VerifiedUsers)),
  viewOption: NBType.enum(InsightViewOption),
  widgetId: NBType.number()
})
export default SocialWebAuthorsWidgetSchema
export type SocialWebAuthorsWidget = InferType<typeof SocialWebAuthorsWidgetSchema>
